import { maxLengthRule } from './main.js';

export function postRulesDefault() {
    return {
        ...maxLengthRule(),
    };
}
